import { ENTRY_LABEL_MAXCHARS } from '@/models/catalog'
import { SHORTTIME_MAX_CHARS, SHORTTIME_MAX_INT } from '@/utils/shorttime'

export const rules = {
	notEmpty: val => (!!val && val.length > 0) || `value is empty`,
	labelMaxLength: val => {
		return (
			(typeof val === 'string' && val.length <= ENTRY_LABEL_MAXCHARS) ||
			`length must be less than ${ENTRY_LABEL_MAXCHARS} characters`
		)
	},
	sanitizeNumber: val => {
		const pattern = /[0-9]$/
		return pattern.test(val) || 'Invalid number'
	},
	timeMax: val =>
		val <= SHORTTIME_MAX_INT ||
		`max value is ${SHORTTIME_MAX_INT} / ${SHORTTIME_MAX_CHARS} characters`,
}

export default {
	qty: [rules.notEmpty, rules.sanitizeNumber],
	label: [rules.notEmpty, rules.labelMaxLength],
	code: [rules.notEmpty, rules.labelMaxLength],
	begin: [rules.notEmpty, rules.timeMax],
	end: [rules.timeMax], // end can be empty
	comment: [], // comment can be empty
}
